import React from 'react'
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom'

import ConnectedApp from './containers/ConnectedApp'
import { ConnectedRouter } from 'connected-react-router'
import WrappedIntlProvider from './containers/WrappedIntlProvider'
import { store, history } from './store'

import './styling/compiled.css'

if (process.env.NODE_ENV !== 'development') {
	// eslint-disable-next-line
	if (location.protocol !== 'https:') {
		// eslint-disable-next-line
		location.protocol = 'https:'
	}
}

export const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJycGNfdG9rZW4iOiJhZjk1Y2UxMGQ5NjBlM2U4OWZmNTM4Mjg2N2UyNWUyNmRlY2VmYTg4In0.jks7ZYfI20hn-w_2oUwyvcxUZqJOFlnz3Lf0lDPv0VFiGS6WkxlgxixuYBbmgKSpmpe6GAfXEJQ9B4G38P9dguSmAzrRV5EhK7A0Dj8K1GBd89g2nAuFK2U5ijDIsRzmK1Ipchp1IpdBJYGidXBhK9y44vaAcA11osx8eMg03obH6G-grHPxk5hveoMzHie1zOuhRKQdb7GUmsVxknkPuP_96uwI0YRCJleBi8WWPr3iqwibfX1MCOta_LxW_4dojeMjW7Ky9bAcd_lda0Zv9EaGQAHZBNTnUsxaHzcYJMYsdOt9OPcVuruYwpNpSae7Kn7aFiEc45gD_Kf98bFBx_wY2YZS_AOqGPwvNIEMZL7lhEIuKFrPMAz9fwSkb6GTZ-lLfL9F-NnvqvGhFZOKCIGLGXf-hF9pFsBujmX52zmFCyxzNKf8N_QbNSwvoYBDFLPjGKaWtnC1M_4TjsLPXOWs7x0hmq1xlfLl4OOE_hwijqljcbyGsCfN6A50SzWItXpbZeRkPz5ty6nWodziJogp552-sYQ4lj0cW0gDomQ7I_Iy8ZDzQrAv0sLUBPb7gdag8fKBRCpyx3lggGkZr0wL59d5VFQ0Mjk1cGRZxuFjfVNrtcQtyV2WZzw70VjmWruENJ3IkjmPOiD8T_6J2X2ahVpucNBIAb_bqKw0KTk'

ReactDOM.render((
	<Provider store={store}>
		<WrappedIntlProvider>
			<ConnectedRouter history={history}>
				<ConnectedApp />
			</ConnectedRouter>
		</WrappedIntlProvider>
	</Provider>
), document.getElementById('root'))
